import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import SocialAuthBlock from 'components/SocialAuthBlock/SocialAuthBlock';
import { Box } from 'rebass';
import LoginForm from 'components/LoginForm';
import { LoginRegisterSuccessCb } from 'utils/auth';
import { KEY_CONTENT_ROUTES } from 'routing';

interface Props extends RouteComponentProps {
  onSuccess: LoginRegisterSuccessCb,
  isTutor?: boolean,
}

const { FORGOT_PASSWORD } = KEY_CONTENT_ROUTES;

function SignInBlock(props: Props) {
  const {
    onSuccess,
    history,
    isTutor,
  } = props;
  return (
    <>
      <SocialAuthBlock
        onSuccess={onSuccess}
        isTutor={isTutor}
      />
      <Box my={3} className="th-word-divider">
        <span>
          or
        </span>
      </Box>
      <LoginForm
        switchToForgotPass={() => history.push(FORGOT_PASSWORD)}
        onSuccess={onSuccess}
        onError={() => {}}
      />
    </>
  );
}

export default withRouter(SignInBlock);
